import { render, staticRenderFns } from "./MusicLibrary.vue?vue&type=template&id=0bae9e10&scoped=true&"
import script from "./MusicLibrary.vue?vue&type=script&lang=js&"
export * from "./MusicLibrary.vue?vue&type=script&lang=js&"
import style0 from "./MusicLibrary.vue?vue&type=style&index=0&id=0bae9e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bae9e10",
  null
  
)

export default component.exports